import { useMeasure } from 'react-use';

export default function Measure({ children }) {
  return children(useMeasure());
}
